import { GenericTranslationLegacy } from '../../Types/culture';
import { MediabankFile, MediabankSearchParams, MediabankSettings, MediabankUploadLocation } from '../../Types/mediabank';
import { ResponseStatus } from '../../Types/base';
import { post, upload, getToken, getSiteRootPath } from '../common';
import { formatUploadFileFields } from '../mediabank';
import { BulkUploadResult } from '../../Types/admin/mediabankBulkUpload';
import { PortalSettingKey } from '../../Types/portal';

const apiPath = 'api/mediabankadmin/';

export async function getFiles(params: MediabankSearchParams) {
	//"type" has changed in react frontend, need to fix it for backend calls
	type MediabankSearchParamsBackend = Omit<MediabankSearchParams, 'type'> & { type?: number };
	const backendParams: MediabankSearchParamsBackend = {
		...params,
		type: params.type?.id,
	};

	const path = `${apiPath}GetFiles`;
	const files = await post<MediabankFile[]>(path, backendParams);
	return files;
}

export async function uploadFile(
	file: File,
	name: string,
	description: string,
	isPrivate: boolean,
	isInvisible: boolean,
	uploadedFrom: MediabankUploadLocation,
	settings?: MediabankSettings,
	nameTranslations?: GenericTranslationLegacy[],
	descriptionTranslations?: GenericTranslationLegacy[],
	urlRewriteTranslations?: GenericTranslationLegacy[]
) {
	const fields = formatUploadFileFields(
		name,
		description,
		isPrivate,
		isInvisible,
		uploadedFrom,
		settings,
		nameTranslations,
		descriptionTranslations,
		urlRewriteTranslations
	);
	const path = `${apiPath}UploadFile`;
	const res = await upload<ResponseStatus>(path, file, fields);
	if (!res?.Success) {
		return;
	}

	return res.Object as MediabankFile;
}

export async function bulkUploadFiles(files: { file: File; portalSettingKeys: PortalSettingKey[] }[], folderId?: number | null): Promise<BulkUploadResult> {
	const path = `${apiPath}BulkUpload`;

	const formData = new FormData();
	if (folderId) formData.append('folderId', folderId.toString());
	files.forEach((item, index) => {
		formData.append(`files`, item.file);
		// Send portal setting keys as a comma-separated string for each file
		formData.append(`portalSettingKeys[${index}]`, item.portalSettingKeys.join(','));
	});

	// Use the helper functions to get proper headers and URL
	const token = getToken();
	const url = getSiteRootPath() + path;

	const headers: Record<string, string> = {
		'Biz-Origin': 'bizreact',
	};
	if (token) {
		headers['Auth-Token'] = token;
	}

	const response = await fetch(url, {
		method: 'POST',
		body: formData,
		headers,
	});

	if (!response.ok) {
		throw new Error(`Upload failed: ${response.statusText}`);
	}

	return await response.json();
}
